<app-resource-library
    [selection]="selection"
    [type_scope_id]="AppScope.E_COURSE"
    (select)="add.emit($event)"
></app-resource-library>
